export { default } from './dispensary-list';
